// Token 管理工具
// 统一管理项目中的 token 存储和读取

const TOKEN_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  AUTH_TOKEN: 'authToken', // 兼容旧代码
  TOKEN: 'token', // 兼容旧代码
};

class TokenManager {
  // 设置 access token
  static setAccessToken(token) {
    if (token) {
      localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, token);
    }
  }

  // 设置 refresh token
  static setRefreshToken(token) {
    if (token) {
      localStorage.setItem(TOKEN_KEYS.REFRESH_TOKEN, token);
    }
  }

  // 设置所有 tokens
  static setTokens(tokens) {
    if (tokens) {
      if (tokens.access_token) {
        this.setAccessToken(tokens.access_token);
      }
      if (tokens.refresh_token) {
        this.setRefreshToken(tokens.refresh_token);
      }
    }
  }

  // 获取 access token
  static getAccessToken() {
    return localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN) || null;
  }

  // 获取 refresh token
  static getRefreshToken() {
    return localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN);
  }

  // 获取 Authorization header
  static getAuthHeader() {
    const token = this.getAccessToken();
    return token ? `Bearer ${token}` : '';
  }

  // 检查是否有有效的 token
  static hasValidToken() {
    return !!this.getAccessToken();
  }

  // 清除所有 tokens
  static clearAllTokens() {
    Object.values(TOKEN_KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
  }

  // 调试方法：打印所有 token 信息
  static debugTokens() {
    console.log('=== Token Manager Debug Info ===');
    Object.entries(TOKEN_KEYS).forEach(([name, key]) => {
      const value = localStorage.getItem(key);
      console.log(`${name} (${key}):`, value ? `[EXISTS] ${value.substring(0, 20)}...` : '[NOT FOUND]');
    });
    console.log('=== End Debug Info ===');
  }
}

export default TokenManager;